import { render, staticRenderFns } from "./SummaryManagementERM.vue?vue&type=template&id=634bd89c&scoped=true"
import script from "./SummaryManagementERM.vue?vue&type=script&lang=js"
export * from "./SummaryManagementERM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634bd89c",
  null
  
)

export default component.exports